import React from 'react';
import { Breadcrumbs } from '../navigation/Breadcrumbs';

// Déclaration pour étendre l'interface Window
declare global {
  interface Window {
    adsbygoogle?: {
      push: (params: unknown) => void;
    };
  }
}

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
  breadcrumbProps?: {
    items?: Array<{ label: string; path: string; icon?: React.ReactNode }>;
    setName?: string;
    missionName?: string;
    cardName?: string;
  };
  disableAds?: boolean;
}

export function PageLayout({ children, className = '', breadcrumbProps, disableAds = false }: PageLayoutProps) {
  React.useEffect(() => {
    if (disableAds) {
      try {
        if (window.adsbygoogle) {
          console.log('PageLayout: Désactivation des publicités');
          const originalAdsbygoogle = window.adsbygoogle;
          
          // Remplacer par une fonction vide pour éviter les erreurs
          window.adsbygoogle = { push: () => {
            console.log('PageLayout: Publicité ignorée (désactivée)');
          }};
          
          return () => {
            console.log('PageLayout: Réactivation des publicités');
            window.adsbygoogle = originalAdsbygoogle;
          };
        }
      } catch (error) {
        console.error('PageLayout: Erreur lors de la désactivation des publicités', error);
      }
    }
  }, [disableAds]);

  return (
    <div className={`w-full mx-auto px-1 sm:px-4 lg:px-8 py-4 sm:py-6 ${className}`}>
      {breadcrumbProps && (
        <div className="mb-4 sm:mb-6">
          <Breadcrumbs {...breadcrumbProps} />
        </div>
      )}
      {children}
    </div>
  );
} 